// extracted by mini-css-extract-plugin
module.exports = {"footer-bar":"FooterBar_footer-bar__2guOD","item":"FooterBar_item__1acF_","link":"FooterBar_link__5A-zt"};